import { FC, ReactNode } from 'react';

interface TableRowProps {
    children?: ReactNode;
    className?: string;
}

const TableRow: FC<TableRowProps> = ({ children, ...props }) => <tr {...props}>{children}</tr>;

export default TableRow;
